import { createAction } from '@reduxjs/toolkit';
import { RequestError, HistoricCommunication, CommunicationsHistoryForm, Callback } from 'types';
import { State } from './types';

export const fetchHistoricCommunication = createAction(
  'historic-communication/fetch',
  (communication: CommunicationsHistoryForm) => ({
    payload: communication,
  })
);

export const fetchedHistoricCommunication = createAction(
  'historic-communication/fetched',
  (data?: HistoricCommunication, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const exportHistoricCommunication = createAction(
  'historic-communication/export',
  (service: CommunicationsHistoryForm, language: string) => ({
    payload: service,
    meta: { language },
  })
);

export const exportedHistoricCommunication = createAction(
  'historic-communication/exported',
  (data?: ArrayBuffer, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const fetchHistoricCommunicationSenders = createAction(
  'historic-communication-senders/fetch',
  (callback?: Callback<unknown, void>) => ({
    payload: undefined,
    meta: { callback },
  })
);

export const fetchedHistoricCommunicationSenders = createAction(
  'historic-communication-senders/fetched',
  (data?: State['senders']['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchHistoricCommunication,
  fetchedHistoricCommunication,
  exportHistoricCommunication,
  exportedHistoricCommunication,
  fetchHistoricCommunicationSenders,
  fetchedHistoricCommunicationSenders,
};
